import styled from 'styled-components';

export const ReportSectionFrame = styled.div`
  background-color: white;
  border-radius: 12px;
  border: 1px solid ${({theme}) => theme.greys.shade30};
`;
